import { useMemo } from "react";

import type { AnalysisReportAdapter } from "@lokasi-ai-web-sdk/agent-ui";

import type { ReportSurfaceStore } from "./surfaceStore";

/**
 * Bridges the store to the SDK. No logic here on purpose: the store is the one
 * place that knows the order operations arrived in.
 */
export function useAnalysisReportAdapter(
  store: ReportSurfaceStore
): AnalysisReportAdapter {
  return useMemo(
    () => ({
      onDelivery: (delivery) => store.applyDelivery(delivery),
      onArtifact: (artifact) => store.noteArtifact(artifact),
      onLifecycle: (event) => store.applyLifecycle(event)
    }),
    [store]
  );
}
